export default {
	namespaced: true,
	state: () => ({
		activeTab: 'rule',
		playListId: 0,
		activityId: 0,
		tabMap: {
			rule: '活动规则',
			rank: '排行榜',
			last: '优质投稿',
		},
		activityName: '',
		shareInfo: {
			hasShare: false,
			taskId: 0,
		},
		isMork: false,
		needGuideSetoutTime: false,
		guideProcessFinish: false,
		fortuneCanClick: true,
		prizeNumber: 0,
		lotteryTrackElement: '开始抽奖',
		fakeTen: false,
		// 开盲盒动画特效
		boxLottie: false,
		isFortuneWheel: true,
	}),
	mutations: {
		setActiveTab(state, data) {
			state.activeTab = data;
		},
		setPlayListId(state, data) {
			if (data !== null && data !== undefined) {
				state.playListId = data;
			}
		},
		setActivityId(state, data) {
			if (data !== null && data !== undefined) {
				state.activityId = data;
			}
		},
		setActivityName(state, data) {
			state.activityName = data;
		},
		setShareInfo(state, data) {
			state.shareInfo = data;
		},
		setIsMork(state, data) {
			state.isMork = data;
		},
		setNeedGuideSetoutTime(state, data) {
			state.needGuideSetoutTime = data;
		},
		setGuideProcessFinish(state, data) {
			state.guideProcessFinish = data;
		},
		setFortuneCanClick(state, data) {
			state.fortuneCanClick = data;
		},
		setPrizeNumber(state, data) {
			state.prizeNumber = data;
		},
		setLotteryTrackElement(state, data) {
			state.lotteryTrackElement = data;
		},
		setFakeTen(state, data) {
			state.fakeTen = data;
		},
		setBoxLottie(state, data) {
			state.boxLottie = data;
		},
		setIsFortuneWheel(state, data) {
			state.isFortuneWheel = data;
		},
	},
	actions: {},
	getters: {
		activeTab(state) {
			return state.activeTab;
		},
		playListId(state) {
			return state.playListId;
		},
		activityId(state) {
			return state.activityId;
		},
		tabMap(state) {
			return state.tabMap;
		},
		activityName(state) {
			return state.activityName;
		},
		shareInfo(state) {
			return state.shareInfo;
		},
		isMork(state) {
			return state.isMork;
		},
		needGuideSetoutTime(state) {
			return state.needGuideSetoutTime;
		},
		guideProcessFinish(state) {
			return state.guideProcessFinish;
		},
		fortuneCanClick(state) {
			return state.fortuneCanClick;
		},
		prizeNumber(state) {
			return state.prizeNumber;
		},
		lotteryTrackElement(state) {
			return state.lotteryTrackElement;
		},
		fakeTen(state) {
			return state.fakeTen;
		},
		boxLottie(state) {
			return state.boxLottie;
		},
		isFortuneWheel(state) {
			return state.isFortuneWheel;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/ActivityPage/modules/activity-template.js